<!-- =========================================================================================
	File Name: TheNavbar.vue
	Description: Navbar component
	Component Name: TheNavbar
	----------------------------------------------------------------------------------------
	Item Name: Vuesax Admin - VueJS Dashboard Admin Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="relative" style="z-index: 10">
    <div class="vx-navbar-wrapper">
      <vs-navbar
        class="vx-navbar navbar-custom"
        :color="navbarColor"
        :class="classObj"
        target-scroll="#hide-scroll-content"
        hide-scroll
        center-collapsed
        v-model="active"
      >
        <!-- <vs-navbar target-scroll="#hide-scroll-content" hide-scroll center-collapsed v-model="active"> -->

        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon
          class="sm:inline-flex xl:hidden cursor-pointer mr-1"
          icon="MenuIcon"
          @click.stop="showSidebar"
        ></feather-icon>
        <h2 class="text-semibold">
          {{
            $store.state.companyName ||
            ($store.state.insysAccount ? "INSYS ADMIN ACCOUNT" : "")
          }}
        </h2>
        <template v-if="breakpoint != 'md'">
          <!-- STARRED PAGES - FIRST 10 -->
          <!-- <ul class="vx-navbar__starred-pages">
					<draggable v-model="starredPagesLimited" :group="{name: 'pinList'}" class="flex cursor-move">
						<li class="starred-page" v-for="page in starredPagesLimited" :key="page.url">
							<vx-tooltip :text="page.label" position="bottom" delay=".3s">
								<feather-icon svgClasses="h-6 w-6" class="p-2 cursor-pointer" :icon="page.labelIcon" @click="$router.push(page.url)"></feather-icon>
							</vx-tooltip>
						</li>
					</draggable>
        </ul> -->

          <!-- STARRED PAGES MORE -->
          <div
            class="vx-navbar__starred-pages--more-dropdown"
            v-if="starredPagesMore.length"
          >
            <vs-dropdown vs-custom-content vs-trigger-click>
              <feather-icon
                icon="ChevronDownIcon"
                svgClasses="h-4 w-4"
                class="cursor-pointer p-2"
              ></feather-icon>
              <vs-dropdown-menu>
                <ul class="vx-navbar__starred-pages-more--list">
                  <draggable
                    v-model="starredPagesMore"
                    :group="{ name: 'pinList' }"
                    class="cursor-move"
                  >
                    <li
                      class="starred-page--more flex items-center cursor-pointer"
                      v-for="page in starredPagesMore"
                      :key="page.url"
                      @click="$router.push(page.url)"
                    >
                      <feather-icon
                        svgClasses="h-5 w-5"
                        class="ml-2 mr-1"
                        :icon="page.labelIcon"
                      ></feather-icon>
                      <span class="px-2 pt-2 pb-1">{{ page.label }}</span>
                    </li>
                  </draggable>
                </ul>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>

          <!-- <div class="bookmark-container">
					<feather-icon icon="StarIcon" :svgClasses="['stoke-current text-warning', {'text-white': navbarColor != '#fff'}]" class="cursor-pointer p-2" @click.stop="showBookmarkPagesDropdown = !showBookmarkPagesDropdown" />
                    <div v-click-outside="outside" class="absolute bookmark-list w-1/3 xl:w-1/4 mt-4" v-if="showBookmarkPagesDropdown">
					<vx-auto-suggest :autoFocus="true" :data="navbarSearchAndPinList" @selected="selected" @actionClicked="actionClicked" inputClassses="w-full" show-action show-pinned background-overlay></vx-auto-suggest>
					</div>
				</div> -->

          <!-- <span >
          <vs-dropdown v-if="userName === `admin`">
            <a
              class="flex items-center"
              style="color: rgb(98, 98, 98)"
              href.prevent
            >
              Master Data
              <i class="material-icons">expand_more</i>
            </a>

            <vs-dropdown-menu>
              <vs-dropdown-item to="/masterdata/barang"
                >Barang</vs-dropdown-item
              >
              <vs-dropdown-item divider to="/masterdata/penerima"
                >Penerima</vs-dropdown-item
              >
              <vs-dropdown-item to="/masterdata/pemasok"
                >Pemasok</vs-dropdown-item
              >
              <vs-dropdown-item to="/masterdata/satuan"
                >Satuan</vs-dropdown-item
              >
              <vs-dropdown-item to="/masterdata/dokumen"
                >Dokumen</vs-dropdown-item
              >
              <vs-dropdown-item to="/masterdata/satuan"
                >Satuan</vs-dropdown-item
              >
              <vs-dropdown-item to="/masterdata/kategori"
                >Kategori</vs-dropdown-item
              >
              <vs-dropdown-item to="/masterdata/brand">Brand</vs-dropdown-item>
              <vs-dropdown-item to="/masterdata/jenis">Jenis</vs-dropdown-item>
              <vs-dropdown-item to="/masterdata/color">Color</vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

          <vs-dropdown v-if="userName === `admin` || userName === `Marketing` ">
            <a
              class="flex items-center"
              style="color: rgb(98, 98, 98)"
              href.prevent
            >
              Marketing
              <i class="material-icons">expand_more</i>
            </a>
            <vs-dropdown-menu>
              <vs-dropdown-item to="/marketing/komposisi"
                >Komposisi</vs-dropdown-item
              >
              <vs-dropdown-item to="/marketing/wo">Wo</vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
          <vs-dropdown v-if="userName === `admin`">
            <a
              class="flex items-center"
              style="color: rgb(98, 98, 98)"
              href.prevent
            >
              Purchasing
              <i class="material-icons">expand_more</i>
            </a>
            <vs-dropdown-menu>
              <vs-dropdown-item to="/purchasing/po">Po</vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

          <vs-dropdown v-if="userName === `admin` || userName === `Warehouse` ">

            <a
              class="flex items-center"
              style="color: rgb(98, 98, 98)"
              href.prevent
            >
              Warehouse
              <i class="material-icons">expand_more</i>
            </a>
            <vs-dropdown-menu>
              <vs-dropdown-item to="/warehouse/barangmasuk"
                >Barang Masuk</vs-dropdown-item
              >
              <vs-dropdown-item to="/warehouse/request"
                >Request</vs-dropdown-item
              >
              <vs-dropdown-item to="/warehouse/materialout"
                >Material Out</vs-dropdown-item
              >
            </vs-dropdown-menu>
          </vs-dropdown>

          <vs-dropdown v-if="userName === `admin`">
            <a
              class="flex items-center"
              style="color: rgb(98, 98, 98)"
              href.prevent
            >
              Cutting
              <i class="material-icons">expand_more</i>
            </a>
            <vs-dropdown-menu>
              <vs-dropdown-item to="/warehouse/request"
                >Request</vs-dropdown-item
              >
              <vs-dropdown-item to="/cutting/incoming"
                >Incoming</vs-dropdown-item
              >
              <vs-dropdown-item to="/cutting/outgoing"
                >Outgoing</vs-dropdown-item
              >
              <vs-dropdown-item to="/cutting/scrap"
                >Scrap</vs-dropdown-item
              >
            </vs-dropdown-menu>
          </vs-dropdown>

          <vs-dropdown v-if="userName === `admin`">
            <a
              class="flex items-center"
              style="color: rgb(98, 98, 98)"
              href.prevent
            >
              Production
              <i class="material-icons">expand_more</i>
            </a>
            <vs-dropdown-menu>
              <vs-dropdown-item to="/warehouse/request"
                >Request</vs-dropdown-item
              >
              <vs-dropdown-item to="/production/sewing"
                >Sewing</vs-dropdown-item
              >
              <vs-dropdown-item to="/production/inputpacking"
                >Finish Good</vs-dropdown-item
              >
            </vs-dropdown-menu>
          </vs-dropdown>
          <vs-dropdown v-if="userName === `admin`">
            <a
              class="flex items-center"
              style="color: rgb(98, 98, 98)"
              href.prevent
            >
              Delivery
              <i class="material-icons">expand_more</i>
            </a>
            <vs-dropdown-menu>
              <vs-dropdown-item to="/delivery/deliveryorder"
                >Delivery Order</vs-dropdown-item
              >
            </vs-dropdown-menu>
          </vs-dropdown>
            <vs-dropdown v-if="userName === `admin`">
            <a
              class="flex items-center"
              style="color: rgb(98, 98, 98)"
              href.prevent
            >
              laporan
              <i class="material-icons">expand_more</i>
            </a>
            <vs-dropdown-menu>
              <vs-dropdown-item to="/laporan/pemasukanbarang"
                >Laporan Pemasukan Barang Per Dokumen Pabean </vs-dropdown-item
              >
              <vs-dropdown-item to="/laporan/pengeluaranbarang"
                >Laporan Pengeluaran Barang Per Dokumen Pabean </vs-dropdown-item
              >
              <vs-dropdown-item to="/laporan/bahanbaku"
                >Laporan Pertanggung Jawaban Bahan Baku dan Penolong </vs-dropdown-item
              >
              <vs-dropdown-item to="/laporan/barangjadi"
                >Laporan Pertanggung Jawaban Barang Jadi </vs-dropdown-item
              >
              <vs-dropdown-item to="/laporan/barangsetengahjadi"
                >Laporan Pertanggung Jawaban Barang Setengah Jadi </vs-dropdown-item
              >
            </vs-dropdown-menu>
          </vs-dropdown>
          </vs-dropdown>
            <vs-dropdown v-if="userName === `admin`">
            <a
              class="flex items-center"
              style="color: rgb(98, 98, 98)"
              href.prevent
            >
              Stock Opname
              <i class="material-icons">expand_more</i>
            </a>
            <vs-dropdown-menu>
              <vs-dropdown-item to="/stockopname"
                >Stock Opname </vs-dropdown-item
              >
            </vs-dropdown-menu>
          </vs-dropdown>

          </span> -->
        </template>

        <!-- I18N -->
        <vs-spacer></vs-spacer>
        <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
          <span class="cursor-pointer flex i18n-locale"
            ><img
              class="h-4 w-5"
              :src="require(`@/assets/images/flags/${$i18n.locale}.png`)"
              :alt="$i18n.locale"
            /><span class="hidden sm:block ml-2">{{
              getCurrentLocaleData.lang
            }}</span></span
          >
          <vs-dropdown-menu class="w-48 i18n-dropdown vx-navbar-dropdown">
            <vs-dropdown-item @click="updateLocale('en')"
              ><img
                class="h-4 w-5 mr-1"
                src="@/assets/images/flags/en.png"
                alt="en"
              />
              &nbsp;English</vs-dropdown-item
            >
            <vs-dropdown-item @click="updateLocale('id')"
              ><img
                class="h-4 w-5 mr-1"
                src="@/assets/images/flags/id.png"
                alt="id"
              />
              &nbsp;Indonesia</vs-dropdown-item
            >
            <vs-dropdown-item @click="updateLocale('kr')"
              ><img
                class="h-4 w-5 mr-1"
                src="@/assets/images/flags/kr.png"
                alt="kr"
              />
              &nbsp;Korea</vs-dropdown-item
            >
          </vs-dropdown-menu>
        </vs-dropdown>

        <!-- SEARCHBAR -->
        <div
          class="search-full-container w-full h-full absolute left-0 rounded-lg"
          :class="{ flex: showFullSearch }"
          v-show="showFullSearch"
        >
          <vx-auto-suggest
            class="w-full"
            inputClassses="w-full vs-input-no-border vs-input-no-shdow-focus no-icon-border"
            :autoFocus="showFullSearch"
            :data="navbarSearchAndPinList"
            icon="SearchIcon"
            placeholder="Search..."
            ref="navbarSearch"
            @closeSearchbar="showFullSearch = false"
            @selected="selected"
            background-overlay
          />
          <div class="absolute right-0 h-full z-50">
            <feather-icon
              icon="XIcon"
              class="px-4 cursor-pointer h-full close-search-icon"
              @click="showFullSearch = false"
            ></feather-icon>
          </div>
        </div>

        <feather-icon
          icon="SearchIcon"
          @click="showFullSearch = true"
          class="cursor-pointer navbar-fuzzy-search ml-4"
        ></feather-icon>
        <p>(F2)</p>

        <!-- CART DROPDOWN -->
        <!-- <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
                <feather-icon icon="ShoppingCartIcon" class="cursor-pointer ml-4 mr-6 mt-1" :badge="cartItems.length"></feather-icon>
        <vs-dropdown-menu class="cart-dropdown vx-navbar-dropdown" :class="{'dropdown-custom': cartItems.length}">-->

        <!-- IF CART HAVE ITEMS: HEADER -->
        <!-- <template v-if="cartItems.length">
                        <div class="notification-header text-center p-5 bg-primary text-white">
                            <h3 class="text-white">{{ cartItems.length }} Item<span v-show="cartItems.length > 1">s</span></h3>
                            <p class="opacity-75">In Your Cart</p>
        </div>-->

        <!-- CART ITEMS -->
        <!-- <VuePerfectScrollbar ref="mainSidebarPs" class="scroll-area--cart-items-dropdowm p-0 mb-10" :settings="settings">
                        <ul class="bordered-items">
        <li v-for="item in cartItems" :key="item.objectID" class="vx-row no-gutter cart-item cursor-pointer">-->

        <!-- IMG COL -->
        <!-- <div class="vx-col w-1/5 item-img-container bg-white flex items-center justify-center">
                                    <img :src="item.image" alt="item" class="cart-dropdown-item-img p-4">
        </div>-->

        <!-- INFO COL -->
        <!-- <div class="vx-col w-4/5 pr-4 pl-2 py-4 flex flex-col justify-center">
                                    <span class="font-medium block cart-item-title truncate">{{ item.name }}</span>
                                    <small class="truncate mb-2">{{ item.description }}</small>
                                    <div class="flex items-center justify-between">
                                        <span class="text-sm font-medium">{{ item.quantity }} <small>x</small> ${{ item.price }}</span>
                                        <feather-icon icon="XIcon" svgClasses="h-4 w-4 cursor-pointer text-danger" class="hover:text-danger" @click.stop="removeItemFromCart(item)" />
                                    </div>
                                </div>
                            </li>
                        </ul>
                        </VuePerfectScrollbar>
                        <div
                            class=" checkout-footer fixed bottom-0 rounded-b-lg text-primary font-semibold w-full p-2 text-center border border-b-0 border-l-0 border-r-0 border-solid d-theme-border-grey-light cursor-pointer"
                            @click="$router.push('/apps/eCommerce/checkout')">

                            <span class="flex items-center justify-center">
                              <feather-icon icon="ShoppingCartIcon" svgClasses="h-4 w-4"></feather-icon>
                              <span class="ml-2">Checkout</span>
                            </span>

                        </div>
                    </template>
        -->
        <!-- IF CART IS EMPTY -->
        <!-- <template v-else>
                        <p class="p-4">Your Cart Is Empty.</p>
                    </template>
                </vs-dropdown-menu>
        </vs-dropdown>-->

        <!-- NOTIFICATIONS -->

        <el-dropdown
          @visible-change="changeDropdown"
          trigger="click"
          vs-custom-content
          vs-trigger-click
          class="cursor-pointer ml-5 mr-5"
        >
          <el-badge
            :value="
              $store.state.notification.filter((f) => f.isRead == false)
                .length > 0
                ? $store.state.notification.filter((f) => f.isRead == false)
                    .length
                : ''
            "
            class="item"
          >
            <el-button @click="clickNotification" icon="el-icon-bell" circle>
            </el-button>
          </el-badge>
          <el-dropdown-menu
            slot="dropdown"
            class="notification-dropdown dropdown-custom vx-navbar-dropdown"
          >
            <div class="notification-top text-center p-5 bg-primary text-white">
              <h3 class="text-white">
                {{
                  $store.state.notification.filter((f) => f.isRead == false)
                    .length
                }}
                New
              </h3>
              <p class="opacity-75">App Notifications</p>
            </div>

            <VuePerfectScrollbar
              ref="mainSidebarPs"
              class="scroll-area--nofications-dropdown p-0 mb-10"
              :settings="settings"
            >
              <ul class="bordered-items">
                <li
                  v-for="ntf in $store.state.notification"
                  :key="ntf.index"
                  class="flex justify-between px-4 py-4 notification cursor-pointer"
                >
                  <div class="flex items-start">
                    <feather-icon
                      :icon="ntf.icon"
                      :svgClasses="[
                        `text-${ntf.category}`,
                        'stroke-current mr-1 h-6 w-6',
                      ]"
                    ></feather-icon>
                    <div class="mx-2">
                      <span
                        class="font-medium block notification-title"
                        :class="[`text-${ntf.category}`]"
                        >{{ ntf.title }}</span
                      >
                      <small>{{ ntf.msg }}</small>
                    </div>
                  </div>
                  <small class="mt-1 whitespace-no-wrap">{{
                    elapsedTime(ntf.time)
                  }}</small>
                </li>
              </ul>
            </VuePerfectScrollbar>
            <div
              class="text-center bg-primary text-white p-2"
              @click="viewNotification"
            >
              <p>View All Notifications</p>
            </div>
          </el-dropdown-menu>
        </el-dropdown>

        <!-- USER META -->
        &nbsp; &nbsp;
        <div class="the-navbar__user-meta flex items-center">
          <div class="text-right leading-tight hidden sm:block">
            <p class="font-semibold">{{ userEmail }}</p>

            <small>{{ userName }} </small>
          </div>
          <vs-dropdown
            vs-custom-content
            vs-trigger-click
            class="cursor-pointer"
          >
            <div class="con-img ml-3">
              <feather-icon
                icon="UserIcon"
                svgClasses="rounded-full shadow-md cursor-pointer block"
              />
              <!-- <img
                v-if="activeUserImg.startsWith('http')"
                key="onlineImg"
                :src="userIcon"
                alt="user-img"
                width="40"
                height="40"
                class="rounded-full shadow-md cursor-pointer block"
              /> -->
              <!-- <img
                v-else
                key="localImg"
                :src="
                  require(`@/assets/images/portrait/small/${activeUserImg}`)
                "
                alt="user-img"
                width="40"
                height="40"
                class="rounded-full shadow-md cursor-pointer block"
              /> -->
            </div>
            <vs-dropdown-menu class="vx-navbar-dropdown">
              <ul style="min-width: 9rem">
                <li
                  class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  @click="$router.push('/pages/profile')"
                >
                  <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
                  <span class="ml-2">Profile</span>
                </li>
                <!-- 
                <li
                  class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  @click="$router.push('/apps/email')"
                >
                  <feather-icon icon="MailIcon" svgClasses="w-4 h-4" />
                  <span class="ml-2">Inbox</span>
                </li>
                <li
                  class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  @click="$router.push('/apps/todo')"
                >
                  <feather-icon icon="CheckSquareIcon" svgClasses="w-4 h-4" />
                  <span class="ml-2">Tasks</span>
                </li>
                <li
                  class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  @click="$router.push('/apps/chat')"
                >
                  <feather-icon icon="MessageSquareIcon" svgClasses="w-4 h-4" />
                  <span class="ml-2">Chat</span>
                </li>
                <li
                  class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  @click="$router.push('/apps/eCommerce/wish-list')"
                >
                  <feather-icon icon="HeartIcon" svgClasses="w-4 h-4" />
                  <span class="ml-2">Wish List</span>
                </li> -->

                <!-- <vs-divider class="m-1"></vs-divider> -->

                <li
                  class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  @click="logout"
                >
                  <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
                  <span class="ml-2">Logout</span>
                </li>
              </ul>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </vs-navbar>
    </div>
  </div>
</template>

<script>
import VxAutoSuggest from "@/components/vx-auto-suggest/VxAutoSuggest.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import draggable from "vuedraggable";
import userIcon from "@/assets/images/userprofile.svg";

export default {
  name: "the-navbar",
  props: {
    navbarColor: {
      type: String,
      default: "#fff",
    },
  },
  data() {
    return {
      navbarSearchAndPinList: this.$store.state.navbarSearchAndPinList,
      searchQuery: "",
      showFullSearch: false,
      active: "",

      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      autoFocusSearch: false,
      showBookmarkPagesDropdown: false,
    };
  },
  watch: {
    $route() {
      if (this.showBookmarkPagesDropdown)
        this.showBookmarkPagesDropdown = false;
    },
  },
  computed: {
    userEmail() {
      return this.$store.getters.userEmail;
    },

    userName() {
      return this.$store.getters.userName;
    },
    // HELPER
    sidebarWidth() {
      return this.$store.state.sidebarWidth;
    },
    breakpoint() {
      return this.$store.state.breakpoint;
    },

    // NAVBAR STYLE
    classObj() {
      if (this.sidebarWidth == "default") return "navbar-default";
      else if (this.sidebarWidth == "reduced") return "navbar-reduced";
      else if (this.sidebarWidth) return "navbar-full";
    },

    // I18N
    getCurrentLocaleData() {
      const locale = this.$i18n.locale;
      if (locale == "en") return { flag: "us", lang: "English" };
      else if (locale == "id") return { flag: "id", lang: "Indonesia" };
      else if (locale == "kr") return { flag: "kr", lang: "Korean" };
      // else if (locale == "de") return { flag: "de", lang: "German" };
    },

    // BOOKMARK & SEARCH
    data() {
      return this.$store.state.navbarSearchAndPinList;
    },
    starredPages() {
      return this.$store.state.starredPages;
    },
    starredPagesLimited: {
      get() {
        return this.starredPages.slice(0, 10);
      },
      set(list) {
        this.$store.dispatch("arrangeStarredPagesLimited", list);
      },
    },
    starredPagesMore: {
      get() {
        return this.starredPages.slice(10);
      },
      set(list) {
        this.$store.dispatch("arrangeStarredPagesMore", list);
      },
    },

    // CART DROPDOWN
    cartItems() {
      return this.$store.state.eCommerce.cartItems.slice().reverse();
    },

    // PROFILE
    // user_displayName() {
    //   // return "Admin"
    //   return localStorage.getItem("userRole");
    //   // return JSON.parse(localStorage.getItem("userInfo")).displayName;
    // },
    activeUserImg() {
      return userIcon;

      // JSON.parse(localStorage.getItem("userInfo")).photoURL ||
      // this.$store.state.AppActiveUser.img
    },
  },
  methods: {
    changeDropdown(data) {
      if (data == false) {
        this.$$readNotif();
      }
    },
    clickNotification() {},
    viewNotification() {
      // this.$$readNotif();
    },
    async updateLocale(locale) {
      if (this.$i18n.locale != locale && this.$store.state.userId) {
        await this.$api.put("api/v1/user/update/" + this.$store.state.userId, {
          lang: locale,
        });
        this.$store.commit("setUserLang", locale);
      }
      this.$i18n.locale = locale;
    },
    showSidebar() {
      this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", true);
    },
    selected(item) {
      this.$router.push(item.url);
      this.showFullSearch = false;
    },
    actionClicked(item) {
      // e.stopPropogation();
      this.$store.dispatch("updateStarredPage", {
        index: item.index,
        val: !item.highlightAction,
      });
    },
    showNavbarSearch() {
      this.showFullSearch = true;
    },
    showSearchbar() {
      this.showFullSearch = true;
    },
    elapsedTime(startTime) {
      let x = new Date(startTime);
      let now = new Date();
      var timeDiff = now - x;
      timeDiff /= 1000;

      var seconds = Math.round(timeDiff);
      timeDiff = Math.floor(timeDiff / 60);

      var minutes = Math.round(timeDiff % 60);
      timeDiff = Math.floor(timeDiff / 60);

      var hours = Math.round(timeDiff % 24);
      timeDiff = Math.floor(timeDiff / 24);

      var days = Math.round(timeDiff % 365);
      timeDiff = Math.floor(timeDiff / 365);

      var years = timeDiff;

      if (years > 0) {
        return years + (years > 1 ? " Years " : " Year ") + "ago";
      } else if (days > 0) {
        return days + (days > 1 ? " Days " : " Day ") + "ago";
      } else if (hours > 0) {
        return hours + (hours > 1 ? " Hrs " : " Hour ") + "ago";
      } else if (minutes > 0) {
        return minutes + (minutes > 1 ? " Mins " : " Min ") + "ago";
      } else if (seconds > 0) {
        return seconds + (seconds > 1 ? `${seconds} sec ago` : "just now");
      }

      return "Just Now";
    },
    logout() {
      this.$store.dispatch("logout");

      // location.reload();
      // console.log(this.$store.dispatch('auth/isRules'));
      // if user is logged in via auth0
      // if (this.$auth.profile) this.$auth.logOut();

      // // if user is looged in via firebase
      // const firebaseCurrentUser = firebase.auth().currentUser;

      // if (firebaseCurrentUser) {
      //   firebase
      //     .auth()
      //     .signOut()
      //     .then(() => {
      //       this.$router.push("/pages/login");
      //       localStorage.removeItem("userInfo");
      //     });
      // }
      // // Change role on logout. Same value as initialRole of acj.js
      // this.$acl.change("admin");
    },
    outside: function () {
      this.showBookmarkPagesDropdown = false;
    },

    // CART DROPDOWN
    removeItemFromCart(item) {
      this.$store.dispatch("eCommerce/toggleItemInCart", item);
    },
  },
  mounted() {
    if (this.$store.state.userLang) {
      this.updateLocale(this.$store.state.userLang);
    }
  },
  created() {
    window.addEventListener("keydown", (e) => {
      if (e.key == "F2") {
        this.showNavbarSearch();
      }
    });
  },
  directives: {
    "click-outside": {
      bind: function (el, binding) {
        const bubble = binding.modifiers.bubble;
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;
        document.addEventListener("click", handler);
      },

      unbind: function (el) {
        document.removeEventListener("click", el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      },
    },
  },
  components: {
    VxAutoSuggest,
    VuePerfectScrollbar,
    draggable,
  },
};
</script>
